<template>
    <div class="antialiased">
        <Sidebar/>
        <div class="page">
            <Header hint="Ketik no. invoice" />
            <div class="content">
                <div class="container"> 
                    <!-- Header Page  -->
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Monitoring Supervisor</h2>
                            </div>
                        </div>
                    </div>

                    <!-- Section Filter Data -->
                    <section class="border-bottom pb-4">
                        <b-container class="bv-example-row px-0">
                            <b-row>
                                <b-col cols="1">
                                    <label for="datepicker-sm">Tanggal</label>
                                </b-col>
                                <b-col cols="4">
                                    <input 
                                        v-model="filter.date" 
                                        type="month" 
                                        class="form-control mb-3"
                                        :max="form.maxDate" 
                                        style="width: 80%;">
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="1">Principal</b-col>
                                <b-col cols="4">
                                    <div class="form-group" style="width: 80%;">
                                        <selectize id="type" v-model="filter.id_principal" >
                                            <option v-for="(principal, index) in data.principals" :key="index" :value="principal.id">{{principal.name}}</option>
                                        </selectize>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="1">Brand</b-col>
                                <b-col>
                                    <b-button
                                        size="sm" 
                                        variant="outline-primary my-1 mr-2"
                                        v-for="(brand, index) in data.brands"
                                        :key="index"
                                        @click="setBrand(brand.id)"
                                        :class="{active: filter.ids_brand.includes(brand.id)}"    
                                        >
                                        {{brand.nama_brand}}    
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-container>
                    </section>

                    <Skeleton type="table" :length="10" class="mt-4 bg-white" v-if="loading"/> 
                    <Nodata class="mt-5" v-if="!loading && data.monitoring.length === 0"/>
                    <!-- Section Result Data -->
                    <div v-if="!loading && data.monitoring.length > 0" class="box mt-4">
                        <div class="card">
                            <div class="table-responsive">
                                <table class="table table-vcenter card-table"> 
                                    <thead>
                                        <tr>
                                            <th style="width:18%;"></th>
                                            <th>Target</th>
                                            <th>
                                                <div class=" mb-3 lower">Volume</div>
                                                <div class="opacity-75">{{header.date}}</div>
                                            </th>
                                            <th>
                                                <div class="text-gray opacity-75">{{header.lastYear}}</div>
                                                Last Year
                                            </th>
                                            <th>
                                                <div class="text-gray opacity-75">{{header.lastMonth}}</div>
                                                Last Month
                                            </th>
                                            <th>
                                                <div class=" mb-3 ">Outlet Active</div>
                                                {{header.date}}
                                            </th>
                                            <th>Last Year</th>
                                            <th>Last Month</th>
                                            <th>
                                                <div class=" mb-3 ">Avg SKU Sold</div>
                                                {{header.date}}
                                            </th>
                                            <th>Last Year</th>
                                            <th>Last Month</th>
                                        </tr>
                                    </thead>
                                    <!-- Create because nested report in table -->
                                    <tbody v-for="(dataSupervisor) in data.monitoring" :key="dataSupervisor.id_supervisor">
                                        <tr class="tr_parent">
                                            <td>{{dataSupervisor.name_supervisor}}</td>
                                            <td>0</td>
                                            <td>{{dataSupervisor.monitoring_spv.volume.date}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.volume.lastYear}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.volume.lastMonth}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.outletActive.date}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.outletActive.lastYear}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.outletActive.lastMonth}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.SKU.date.toFixed(2)}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.SKU.lastYear.toFixed(2)}}</td>
                                            <td>{{dataSupervisor.monitoring_spv.SKU.lastMonth.toFixed(2)}}</td>
                                        </tr>
                                        <template v-for="(dataTim) in dataSupervisor.details_spv" >
                                            <!-- Create because nested report in table -->
                                            <tr :key="dataTim.id_tim" v-b-toggle="'collapse-'+dataTim.id_tim" class="tr_tim">
                                                <td class="pl-6">{{dataTim.nama_tim}}</td>
                                                <td>0</td>
                                                <td>{{dataTim.monitoring_tim.volume.date}}</td>
                                                <td>{{dataTim.monitoring_tim.volume.lastYear}}</td>
                                                <td>{{dataTim.monitoring_tim.volume.lastMonth}}</td>
                                                <td>{{dataTim.monitoring_tim.outletActive.date}}</td>
                                                <td>{{dataTim.monitoring_tim.outletActive.lastYear}}</td>
                                                <td>{{dataTim.monitoring_tim.outletActive.lastMonth}}</td>
                                                <td>{{dataTim.monitoring_tim.SKU.date.toFixed(2)}}</td>
                                                <td>{{dataTim.monitoring_tim.SKU.lastYear.toFixed(2)}}</td>
                                                <td>{{dataTim.monitoring_tim.SKU.lastMonth.toFixed(2)}}</td>
                                            </tr>
                                            <tr v-for="(dataSales) in dataTim.details_tim" :key="dataSales.id_salesman" class="tr_salesman">
                                                <td class="d-flex justify-content-end"><b-collapse :id='"collapse-"+dataTim.id_tim' class="text-truncate title" style="max-width: 50%;">{{dataSales.nama_salesman}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>0</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.volume.date}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.volume.lastYear}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.volume.lastMonth}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.outletActive.date}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.outletActive.lastYear}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.outletActive.lastMonth}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.SKU.date.toFixed(2)}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.SKU.lastYear.toFixed(2)}}</b-collapse></td>
                                                <td><b-collapse :id='"collapse-"+dataTim.id_tim'>{{dataSales.monitoring_sales.SKU.lastMonth.toFixed(2)}}</b-collapse></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    // Method and State u can see in the file store/monitoring_salesman.
    computed: {
        ...mapState(["loading"]),
        ...mapState("monitoring_salesman",['header','filter','form','data']),
    },
    methods: {
        ...mapActions("monitoring_salesman",["getFilter","getBrands","updateHeader","setBrand","getMonitoring"]),
    },
    watch:{
        'filter.id_principal': function () {
            this.getBrands()
        },
        'filter.date' : function(){
            this.updateHeader()
        },
    },
    mounted(){
        this.getFilter()
    }
}
</script>
<style scoped>
    td{
        border-bottom: none !important;
        font-size: 0.75rem;
    }
    .tr_parent {
        border-bottom: 1px solid rgba(110, 117, 130, 0.2);
    }

    .tr_parent td {
        padding-top: 1%;
        /* font-weight: 420; */
    }

    .tr_tim td{
        padding-bottom: 0px;
        padding-top: 0px;
    }
    .tr_salesman td{
        padding: 0.5rem !important; 
    }
    .tr_salesman .title{
        max-width: 80%;
        margin-right: 8%;
    }

    th{
        text-transform: capitalize !important;
        font-size: 0.74rem !important;
        font-weight: 430 !important;
    }
</style>


